import { has, merge } from 'lodash';
import type { CustomControlCode } from '@common/enums';
import type { HookConfig, Hooks } from '@common/formEngine/hooks.types';
import type { HookData } from '@common/interfaces/serviceContext.types';
import { getHookData as getApiHookData } from '@frontend/services/api/processActivitiesApiService';

function shouldUpdateHookData(hookConfig: HookConfig, changedData: Record<string, unknown>): boolean {
    return hookConfig.dependencyFields.some((key) => has(changedData, key));
}

export async function getHookData<TCustomControlCode extends CustomControlCode = CustomControlCode>({
    abortSignal,
    customControlCode,
    changedData,
    customControlVersion,
    hooks,
    patientId,
    processActivityContextData,
}: {
    abortSignal: AbortSignal;
    changedData?: Record<string, unknown>;
    customControlCode: TCustomControlCode;
    customControlVersion: number;
    hooks: Hooks;
    patientId: string;
    processActivityContextData: Record<string, unknown>;
}): Promise<Record<string, HookData<TCustomControlCode>>> {
    let hookData = processActivityContextData.hookData ?? {};
    for (const [hookName, hookConfig] of Object.entries(hooks)) {
        if (changedData && !shouldUpdateHookData(hookConfig, changedData)) {
            continue;
        }

        const result = await getApiHookData({
            hookName,
            requestBody: {
                customControlCode,
                customControlVersion,
                patientId,
                processActivityContextData,
            },
            signal: abortSignal,
        });
        hookData = merge(hookData, result);
    }

    return hookData as Record<string, HookData<TCustomControlCode>>;
}
